export const html =
	`<!DOCTYPE html>
    <html>
    
    <head>
        <link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600&display=swap" rel="stylesheet">
    
        <style>
            body {
                margin: 0px;
                font-family: 'Source Sans Pro', sans-serif;
                width: 1080px;
                height: 1920px;
            }
    
            .outerContainer {
                width: 1080px;
                height: 1920px;
                max-width: 1080px;
                max-height: 1920px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                position: relative;
            }
    
            .logoImgContainer {
                display: -webkit-box;
                -webkit-box-pack: center;
            }
    
            .logoInnerContainer {
                display: -webkit-box;
                -webkit-box-pack: center;
                max-width: 80%;
                height: 100px;
            }
    
            .logoInnerTopContainer {
                margin-top: 75px;
                margin-bottom: 50px;
            }
    
            .logoInnerBottomContainer {
                margin-top: 50px;
                margin-bottom: 75px;
            }
    
            .logoImgContent {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
            }
    
            .innerAboveSqureContainer {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                /* -webkit-box-pack: center; */
                -webkit-box-flex: 1;
                -webkit-box-align: center;
            }
    
            .innerBellowSqureContainer {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                /* -webkit-box-pack: center; */
                -webkit-box-flex: 1;
                -webkit-box-align: center;
                position: absolute;
                bottom: 0%;
            }
    
            .innerContainerCircleImage {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-box-pack: center;
                -webkit-box-flex: 1;
                -webkit-box-align: center;
            }
    
            .textOuterContainer {
                max-width: 80%;
                /* margin: 50px 0px; */
                display: -webkit-box;
                -webkit-box-pack: center;
                -webkit-box-orient: vertical;
                -webkit-box-align: center;
            }
    
            .text {
                margin: 0px;
                text-align: center;
                font-size: 115px;
                white-space: pre-wrap;
                letter-spacing: 15px;
            }
    
            .subText {
                font-size: 50px;
                margin: 0px;
                margin-top: 15px;
                text-align: center;
                white-space: pre-wrap;
            }
    
            .heroImgBellowTextContainer {
                width: 100%;
                display: flex;
                margin-top: 50px;
            }
    
            .heroImgaboveTextContainer {
                width: 100%;
                display: flex;
                margin-bottom: 50px;
            }
    
            .heroImgContent {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
            }
    
            .heroCircleImgContent {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
                border-radius: 50%;
                margin: 50px 0px;
            }
    
            .heroCircleImgContainer {
                display: -webkit-box;
                -webkit-box-pack: center;
            }
    
            .heroCircleImgInnerContainer {
                border-radius: 50%;
                max-width: 80%;
            }
        </style>
    </head>
    
    <body>
        <div class="outerContainer" style="background-color: {{bgColour}}">
            {{#ifLogoLink logoLink}}
            {{#ifLogoPlacementTop logoPlacement}}
            <div class="logoImgContainer">
                <div class="logoInnerContainer logoInnerTopContainer">
                    <img src="{{logoLink}}" class="logoImgContent" />
                </div>
            </div>
            {{/ifLogoPlacementTop}}
            {{/ifLogoLink}}
            <!-- checkIng Image sqoure or circle -->
            {{#ifHeroImageMode heroImageMode}}
            <!-- checkIng Sqoure Image above or below -->
            {{#ifTextPlacementAboveHero textPlacement}}
            <div class="innerBellowSqureContainer">
                {{#ifTextPlacementAboveHero textPlacement}}
                <div class="textOuterContainer">
                    {{#ifText text}}
                    <h1 class="text" style="color: {{textColour}}">{{text}}</h1>
                    {{/ifText}}
                    {{#ifSubText subText}}
                    <p class="subText" style="color: {{subTextColour}}">{{subText}}</p>
                    {{/ifSubText}}
                </div>
                {{/ifTextPlacementAboveHero}}
    
                <div class="heroImgBellowTextContainer">
                    <img src="{{heroImageLink}}" class="heroImgContent" />
                </div>
    
                {{#ifTextPlacementBelowHero textPlacement}}
                <div class="textOuterContainer">
                    {{#ifText text}}
                    <h1 class="text" style="color: {{textColour}}">{{text}}</h1>
                    {{/ifText}}
    
                    {{#ifSubText subText}}
                    <p class="subText" style="color: {{subTextColour}}">{{subText}}</p>
                    {{/ifSubText}}
                </div>
                {{/ifTextPlacementBelowHero}}
    
            </div>
            {{else}}
            <div class="innerAboveSqureContainer">
                {{#ifTextPlacementAboveHero textPlacement}}
                <div class="textOuterContainer">
                    {{#ifText text}}
                    <h1 class="text" style="color: {{textColour}}">{{text}}</h1>
                    {{/ifText}}
                    {{#ifSubText subText}}
                    <p class="subText" style="color: {{subTextColour}}">{{subText}}</p>
                    {{/ifSubText}}
                </div>
                {{/ifTextPlacementAboveHero}}
                
                <div class="heroImgaboveTextContainer">
                    <img src="{{heroImageLink}}" class="heroImgContent" />
                </div>
    
                {{#ifTextPlacementBelowHero textPlacement}}
                <div class="textOuterContainer">
                    {{#ifText text}}
                    <h1 class="text" style="color: {{textColour}}">{{text}}</h1>
                    {{/ifText}}
    
                    {{#ifSubText subText}}
                    <p class="subText" style="color: {{subTextColour}}">{{subText}}</p>
                    {{/ifSubText}}
                </div>
                {{/ifTextPlacementBelowHero}}
    
            </div>
    
            {{/ifTextPlacementAboveHero}}
            {{else}}
    
            <div class="innerContainerCircleImage">
    
                {{#ifTextPlacementAboveHero textPlacement}}
                <div class="textOuterContainer">
                    {{#ifText text}}
                    <h1 class="text" style="color: {{textColour}}">{{text}}</h1>
                    {{/ifText}}
                    {{#ifSubText subText}}
                    <p class="subText" style="color: {{subTextColour}}">{{subText}}</p>
                    {{/ifSubText}}
                </div>
                {{/ifTextPlacementAboveHero}}
    
                <div class="heroCircleImgContainer">
                    <div class="heroCircleImgInnerContainer">
                        <img src="{{heroImageLink}}" class="heroCircleImgContent" />
                    </div>
                </div>
    
                {{#ifTextPlacementBelowHero textPlacement}}
                <div class="textOuterContainer">
                    {{#ifText text}}
                    <h1 class="text" style="color: {{textColour}}">{{text}}</h1>
                    {{/ifText}}
    
                    {{#ifSubText subText}}
                    <p class="subText" style="color: {{subTextColour}}">{{subText}}</p>
                    {{/ifSubText}}
                </div>
                {{/ifTextPlacementBelowHero}}
    
            </div>
            {{/ifHeroImageMode}}
            {{#ifLogoLink logoLink}}
            {{#ifLogoPlacementBottom logoPlacement}}
            <div class="logoImgContainer">
                <div class="logoInnerContainer logoInnerBottomContainer">
                    <img src="{{logoLink}}" class="logoImgContent" />
                </div>
            </div>
            {{/ifLogoPlacementBottom}}
            {{/ifLogoLink}}
        </div>
    
    </body>
    
    </html>`



export const templateDataMap = {
  TEMPLATE1: {
    label: 'Layout 1 (Circle Top)',
    logoLink: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Sony_logo.svg/440px-Sony_logo.svg.png',
    logoPlacement: 'BOTTOM',
    bgColour: 'yellow',
    textPlacement: 'BELOWHERO',
    text: 'Zooming\nis the new\nhandshake',
    textColour: 'black',
    subText: 'Lorem Ipsum is simply dummy text',
    subTextColour: 'black',
    heroImageLink: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Sony_headquarters_%28crop%29.jpg',
    heroImageMode: 'CIRCLE'
  },
  TEMPLATE2: {
    label: 'Layout 2 (Circle Bottom)',
    logoLink: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/2880px-Google_2015_logo.svg.png',
    logoPlacement: 'BOTTOM',
    bgColour: 'yellow',
    textPlacement: 'ABOVEHERO',
    text: 'Zooming\nis the new\nhandshake',
    textColour: 'black',
    subText: 'Lorem Ipsum is simply dummy text',
    subTextColour: 'black',
    heroImageLink: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Sony_headquarters_%28crop%29.jpg',
    heroImageMode: 'CIRCLE'
  },
  TEMPLATE3: {
    label: 'Layout 3 (Square Top)',
    logoLink: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/2880px-Google_2015_logo.svg.png',
    logoPlacement: 'BOTTOM',
    bgColour: 'black',
    textPlacement: 'BELOWHERO',
    text: 'Zooming\nis the new\nhandshake',
    textColour: 'yellow',
    subText: 'Lorem Ipsum is simply dummy text',
    subTextColour: 'yellow',
    heroImageLink: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Sony_headquarters_%28crop%29.jpg',
    heroImageMode: 'SQUARE'
  },
  TEMPLATE4: {
    label: 'Layout 4 (Square Bottom)',
    logoLink: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/2880px-Google_2015_logo.svg.png',
    logoPlacement: 'TOP',
    bgColour: 'black',
    textPlacement: 'ABOVEHERO',
    text: 'Zooming\nis the new\nhandshake',
    textColour: 'yellow',
    subText: 'Lorem Ipsum is simply dummy text',
    subTextColour: 'yellow',
    heroImageLink: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Sony_headquarters_%28crop%29.jpg',
    heroImageMode: 'SQUARE'
  },
  TEMPLATE5: {
    label: 'Layout 5 (Circle Left)',
    logoLink: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Sony_logo.svg/440px-Sony_logo.svg.png',
    logoPlacement: 'BOTTOM',
    bgColour: 'yellow',
    textPlacement: 'RIGHTHERO',
    text: 'Zooming\nis the new\nhandshake',
    textColour: 'black',
    subText: 'Lorem Ipsum is simply dummy text',
    subTextColour: 'black',
    heroImageLink: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Sony_headquarters_%28crop%29.jpg',
    heroImageMode: 'CIRCLE'
  },
  TEMPLATE6: {
    label: 'Layout 6 (Circle Right)',
    logoLink: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/2880px-Google_2015_logo.svg.png',
    logoPlacement: 'BOTTOM',
    bgColour: 'yellow',
    textPlacement: 'LEFTHERO',
    text: 'Zooming\nis the new\nhandshake',
    textColour: 'black',
    subText: 'Lorem Ipsum is simply dummy text',
    subTextColour: 'black',
    heroImageLink: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Sony_headquarters_%28crop%29.jpg',
    heroImageMode: 'CIRCLE'
  },
  TEMPLATE7: {
    label: 'Layout 7 (Square Left)',
    logoLink: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/2880px-Google_2015_logo.svg.png',
    logoPlacement: 'BOTTOM',
    bgColour: 'black',
    textPlacement: 'RIGHTHERO',
    text: 'Zooming\nis the new\nhandshake',
    textColour: 'yellow',
    subText: 'Lorem Ipsum is simply dummy text',
    subTextColour: 'yellow',
    heroImageLink: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Sony_headquarters_%28crop%29.jpg',
    heroImageMode: 'SQUARE'
  },
  TEMPLATE8: {
    label: 'Layout 8 (Square Right)',
    logoLink: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/2880px-Google_2015_logo.svg.png',
    logoPlacement: 'TOP',
    bgColour: 'black',
    textPlacement: 'LEFTHERO',
    text: 'Zooming\nis the new\nhandshake',
    textColour: 'yellow',
    subText: 'Lorem Ipsum is simply dummy text',
    subTextColour: 'yellow',
    heroImageLink: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Sony_headquarters_%28crop%29.jpg',
    heroImageMode: 'SQUARE'
  }
}

export const htmlHorizontal = `<!DOCTYPE html>
<html>

<head>
  <link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600&display=swap" rel="stylesheet">

  <style>
    body {
      margin: 0px;
      font-family: 'Source Sans Pro', sans-serif;
      width: 1920px;
      height: 1080px;
    }

    .outerContainer {
      width: 1920px;
      height: 1080px;
      max-width: 1920px;
      max-height: 1080px;
      display: -webkit-box;
      -webkit-box-flex: 1;
      -webkit-box-orient: horizontal;
      position: relative;
    }

    .logoImgContainer {
      display: -webkit-box;
      -webkit-box-pack: center;
      margin-top: 50px;
    }

    .logoInnerContainer {
      display: -webkit-box;
      -webkit-box-pack: center;
      max-width: 80%;
      height: 100px;
    }

    .logoInnerTopContainer {
      margin-top: 75px;
      margin-bottom: 50px;
    }

    .logoInnerBottomContainer {
      margin-top: 50px;
      margin-bottom: 75px;
    }

    .logoImgContent {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    .innerLeftSqureContainer {
      display: -webkit-box;
      -webkit-box-orient: horizontal;
      -webkit-box-flex: 1;
      -webkit-box-align: center;
    }

    .innerRightSqureContainer {
      display: -webkit-box;
      -webkit-box-orient: horizontal;
      -webkit-box-flex: 1;
      -webkit-box-align: center;
    }

    .innerContainerCircleImage {
      display: -webkit-box;
      -webkit-box-orient: horizontal;
      -webkit-box-pack: center;
      -webkit-box-flex: 1;
      -webkit-box-align: center;
    }

    .textOuterContainer {
      /* max-width: 50%; */
      display: -webkit-box;
      -webkit-box-flex: 1;
      -webkit-box-pack: center;
      -webkit-box-orient: vertical;
      -webkit-box-align: center;
      margin-left: 50px;
      margin-right: 50px;
    }

    .circleTextOuterContainer {
      display: -webkit-box;
      -webkit-box-flex: 1;
      -webkit-box-pack: center;
      -webkit-box-orient: vertical;
      -webkit-box-align: center;
      margin-left: 80px;
      margin-right: 20px;
    }
    .circleRightTextOuterContainer {
      display: -webkit-box;
      -webkit-box-flex: 1;
      -webkit-box-pack: center;
      -webkit-box-orient: vertical;
      -webkit-box-align: center;
      margin-left: 20px;
      margin-right: 80px;
    }

    .text {
      margin: 0px;
      text-align: center;
      font-size: 115px;
      white-space: pre-wrap;
      letter-spacing: 15px;
    }

    .subText {
      font-size: 50px;
      margin: 0px;
      margin-top: 15px;
      text-align: center;
      white-space: pre-wrap;
    }

    .heroImgRightTextContainer {
      height: 100%;
      display: flex;
      /* position: absolute;
      right: 0; */
    }

    .heroImgLeftTextContainer {
      height: 100%;
      display: flex;
      /* margin-right: 50px; */
    }

    .heroImgContent {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }

    .heroCircleImgContent {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }

    .heroCircleImgContainer {
      display: -webkit-box;
      -webkit-box-pack: center;
    }

    .heroCircleImgInnerContainer {
      border-radius: 50%;
      height: 900px;
      /* margin-left: 50px; */
      margin: 30px;
      margin-right: 80px;
    }

    .heroCircleLeftImgInnerContainer {
      border-radius: 50%;
      height: 900px;
      /* margin-right: 50px; */
      margin: 30px;
      margin-left: 80px;
    }
  </style>
</head>

<body>
  <div class="outerContainer" style="background-color: {{bgColour}}">

    <!-- checkIng Image sqoure or circle -->
    {{#ifHeroImageMode heroImageMode}}
    <!-- checkIng Sqoure Image Right or Left -->
    {{#ifTextPlacementLeftHero textPlacement}}
    <div class="innerRightSqureContainer">
      {{#ifTextPlacementLeftHero textPlacement}}
      <div class="textOuterContainer">
        {{#ifText text}}
        <h1 class="text" style="color: {{textColour}}">{{text}}</h1>
        {{/ifText}}
        {{#ifSubText subText}}
        <p class="subText" style="color: {{subTextColour}}">{{subText}}</p>
        {{/ifSubText}}
        {{#ifLogoLink logoLink}}

        <div class="logoImgContainer">
          <div class="logoInnerContainer">
            <img src="{{logoLink}}" class="logoImgContent" />
          </div>
        </div>
        {{/ifLogoLink}}
      </div>
      {{/ifTextPlacementLeftHero}}
      <div class="heroImgRightTextContainer">
        <img src="{{heroImageLink}}" class="heroImgContent" />
      </div>
    </div>
    {{else}}
    <div class="innerLeftSqureContainer">
      <div class="heroImgLeftTextContainer">
        <img src="{{heroImageLink}}" class="heroImgContent" />
      </div>

      {{#ifTextPlacementRightHero textPlacement}}
      <div class="textOuterContainer">
        {{#ifText text}}
        <h1 class="text" style="color: {{textColour}}">{{text}}</h1>
        {{/ifText}}

        {{#ifSubText subText}}
        <p class="subText" style="color: {{subTextColour}}">{{subText}}</p>
        {{/ifSubText}}
        {{#ifLogoLink logoLink}}

        <div class="logoImgContainer">
          <div class="logoInnerContainer">
            <img src="{{logoLink}}" class="logoImgContent" />
          </div>
        </div>
        {{/ifLogoLink}}
      </div>
      {{/ifTextPlacementRightHero}}

    </div>

    {{/ifTextPlacementLeftHero}}
    {{else}}

    <div class="innerContainerCircleImage">

      {{#ifTextPlacementLeftHero textPlacement}}
      {{#ifContent text subText logoLink}}
      <div class="circleTextOuterContainer">
        {{#ifText text}}
        <h1 class="text" style="color: {{textColour}}">{{text}}</h1>
        {{/ifText}}
        {{#ifSubText subText}}
        <p class="subText" style="color: {{subTextColour}}">{{subText}}</p>
        {{/ifSubText}}
        {{#ifLogoLink logoLink}}

        <div class="logoImgContainer">
          <div class="logoInnerContainer">
            <img src="{{logoLink}}" class="logoImgContent" />
          </div>
        </div>
        {{/ifLogoLink}}
      </div>
      {{/ifContent}}


      <div class="heroCircleImgInnerContainer">
        <img src="{{heroImageLink}}" class="heroCircleImgContent" />
      </div>
      {{/ifTextPlacementLeftHero}}


      {{#ifTextPlacementRightHero textPlacement}}
      <div class="heroCircleLeftImgInnerContainer">
        <img src="{{heroImageLink}}" class="heroCircleImgContent" />
      </div>
      {{#ifContent text subText logoLink}}
      <div class="circleRightTextOuterContainer">
        {{#ifText text}}
        <h1 class="text" style="color: {{textColour}}">{{text}}</h1>
        {{/ifText}}

        {{#ifSubText subText}}
        <p class="subText" style="color: {{subTextColour}}">{{subText}}</p>
        {{/ifSubText}}
        {{#ifLogoLink logoLink}}

        <div class="logoImgContainer">
          <div class="logoInnerContainer">
            <img src="{{logoLink}}" class="logoImgContent" />
          </div>
        </div>
        {{/ifLogoLink}}
      </div>
      {{/ifContent}}
      {{/ifTextPlacementRightHero}}

    </div>
    {{/ifHeroImageMode}}
  </div>

</body>

</html>`



// logoLink: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Sony_logo.svg/440px-Sony_logo.svg.png',
// bgColour: 'yellow',
// text: 'Zooming\nis the new\nhandshake',
// textColour: 'black',
// subText: 'Lorem Ipsum is simply dummy text',
// subTextColour: 'black',
// heroImageLink: 'https://upload.wikimedia.org/wikipedia/commons/5/54/Sony_headquarters_%28crop%29.jpg',




// WEBPACK FOOTER //
// ./src/helpers/template.js